import styled from 'styled-components';

export const DiagnosticsStepsVideoContainer = styled.div`
  margin: 0 auto;
  padding-top: 64px;
  max-width: 887px;
  width: 100%;

  > div {
    position: relative;
    padding-bottom: 56.25%;

    iframe {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
    }
  }
`;
